"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getScroll;

function getScroll(target, top) {
  if (typeof window === 'undefined') {
    return 0;
  }

  var prop = top ? 'pageYOffset' : 'pageXOffset';
  var method = top ? 'scrollTop' : 'scrollLeft';
  var isWindow = target === window;
  var ret = isWindow ? target[prop] : target[method]; // ie6,7,8 standard mode

  if (isWindow && typeof ret !== 'number') {
    ret = document.documentElement[method];
  }

  return ret;
}
//# sourceMappingURL=getScroll.js.map



//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/_util/getScroll.js
// module id = 142
// module chunks = 0